// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IAol","index":"styles_index__25L6N"};